import { Component, Inject } from '@angular/core';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';
import { VER_CONFIG } from 'src/app/core/injection.token';
import { SettingsAPIService } from 'src/app/extensions/services/api/settings-api.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  standalone: false,
})
export class AboutComponent {
  public angularVersion: string;
  public tenantApiSyncVersion: string;
  public portalApiSyncVersion: string;
  public portalApiAsyncVersion: string;
  public adressApiSyncVersion: string;
  public portalNgFrontendVersion: string;

  constructor(
    private _settingsAPIService: SettingsAPIService,
    @Inject(VER_CONFIG) private _verConfig: ver.VerData
  ) {
    this.portalNgFrontendVersion = this._verConfig.ver;

    const source = forkJoin([
      this._settingsAPIService.GetTenantApiSyncVersion(),
      this._settingsAPIService.GetPortalApiSyncVersion(),
    ]);

    source.subscribe(([tenantApiSyncVersion, portalApiSyncVersion]) => {
      this.tenantApiSyncVersion = tenantApiSyncVersion;
      this.portalApiSyncVersion = portalApiSyncVersion;
    });
  }
}
